export const SILENT_PDF_DOWNLOAD_EVENT = 'guincho:silentPdfDownload' as const;

export type PdfDownloadPlatform = 'android-mobile-web' | 'ios-mobile-web' | 'desktop-web' | 'unknown-web';

export interface SilentPdfDownloadEventDetail {
  fileName: string;
  blob: Blob;
  blobUrl: string;
  messageHint: string;
  platform: PdfDownloadPlatform;
}

export const dispatchSilentPdfDownloadEvent = (detail: SilentPdfDownloadEventDetail) => {
  if (typeof window === 'undefined' || typeof CustomEvent === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SILENT_PDF_DOWNLOAD_EVENT, { detail }));
};

declare global {
  interface WindowEventMap {
    'guincho:silentPdfDownload': CustomEvent<SilentPdfDownloadEventDetail>;
  }
}

export {};
